import { parseJSON } from './parser';
import defaultConfig, { defaultRoleNames } from '../pages/Settings/configs/role-config';

export const getSubAccAccess = (currentUser, access = '') => {
  if (!currentUser || JSON.stringify(currentUser) === '{}') return false;

  let currentPath = parseJSON(currentUser.path, []);

  // if it default role name we use default config
  if (defaultRoleNames.includes(currentUser?.roleName)) {
    currentPath = defaultConfig.map(i => ({ ...i, checked: i.scope.includes(currentUser?.roleName) }));
  }

  const subAccountAccess = currentPath
    .filter(item => item.checked)
    .map(item => item.name)
    .includes(access);

  return currentUser.role === 'admin' ? subAccountAccess : true;
};
